export const THEME_MODE_ATTRIBUTE = 'theme-mode';
